module.exports = __webpack_public_path__ + "img/ico-woocommerce.e635f526.svg";